import {DxOperationResultType} from "../../../dx-core/domain/common/dx-operation-result-type";
import {DxUser} from "../user/dx-user";

/**
 *  `DxAuthentication` - контейнер для обеспечения возможности реализации
 *  единого механизма аунтификации для разных стратегий.
 **/
export class DxAuthentication {
  /**
   *   Не буду пока забуриваться в абстракции.
   *   Да и instanceof на клиенте... хз не очень я это люблю.
   *   Поэтому пусть пока будет при помощи енума.
   *   Можно конечно выбрасывать ошибку при провале аунтификации, но так как в typescript
   *   исключения не прописываются в сигнатуре методов, то это не очевидно.
   **/
  private _authResult: DxOperationResultType;

  /** Токен - зашифрованная информация **/
  private _token: string;
  
  /** RefreshToken - токен для получения нового токена **/
  private _refreshToken: string;

  /** Причина проваленной аунтификации **/
  private _error: string;

  private _user: DxUser;

  get authResult(): DxOperationResultType {
    return this._authResult;
  }

  set authResult(value: DxOperationResultType) {
    this._authResult = value;
  }

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get refreshToken(): string {
    return this._refreshToken;
  }

  set refreshToken(value: string) {
    this._refreshToken = value;
  }

  get user(): DxUser {
    return this._user;
  }

  set user(value: DxUser) {
    this._user = value;
  }

  get error(): string {
    return this._error;
  }

  set error(value: string) {
    this._error = value;
  }
}
